import { __require as t } from "../ClientBuilder.mjs";
var e, n;
function r() {
  if (n) return e;
  n = 1;
  const r = t();
  function i(t) {
    return new r(t);
  }
  return e = {
    usStreet: function (t) {
      return i(t).buildUsStreetApiClient();
    },
    usAutocompletePro: function (t) {
      return i(t).buildUsAutocompleteProClient();
    },
    usExtract: function (t) {
      return i(t).buildUsExtractClient();
    },
    usZipcode: function (t) {
      return i(t).buildUsZipcodeClient();
    },
    internationalStreet: function (t) {
      return i(t).buildInternationalStreetClient();
    },
    usReverseGeo: function (t) {
      return i(t).buildUsReverseGeoClient();
    },
    internationalAddressAutocomplete: function (t) {
      return i(t).buildInternationalAddressAutocompleteClient();
    },
    usEnrichment: function (t) {
      return i(t).buildUsEnrichmentClient();
    }
  };
}
export { r as __require };